exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3mNOS {\n  display: inline-block;\n  padding: 0 9px 0 15px;\n  border: 1px solid #A0A0A0;\n  color: #A0A0A0;\n  margin: 5px;\n}\n._3mNOS ._2rbvR {\n  display: inline-block;\n  padding: 6px 0;\n}\n._3mNOS .iSlGa {\n  display: inline-block;\n  cursor: pointer;\n  padding: 6px;\n}\n", ""]);

// Exports
exports.locals = {
	"container": "_3mNOS",
	"text": "_2rbvR",
	"button": "iSlGa"
};